module.exports = __webpack_public_path__ + "img/mikko.cf5cb618.jpeg";